import type { Locale } from '@backmarket/http-api'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'

export default function createNumberFormatter(locale: Locale) {
  return (value: number) =>
    Intl.NumberFormat(toBcp47Locale(locale)).format(value)
}
